import { ThemeProvider } from "@material-ui/styles";
import React from "react";
import { withRouter } from "react-router";
import { Route, Router, Switch } from "react-router-dom";
import PrivateRoute from "./components/PrivateRouter/PrivateRouter";
import History from "./History/History";
import CategoryProduct from "./pages/Category/CategoryProduct";
import CategoryTenant from "./pages/Category/CategoryTenant";
import Home from "./pages/Home";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound/NotFound";
import NewOrder from "./pages/Order/NewOrder";
import PromoMall from "./pages/Promotion/PromoMall";
import PromoManagement from "./pages/Promotion/PromoManagement";
import PromoTenant from "./pages/Promotion/PromoTenant";
import Property from "./pages/Property";
import Role from "./pages/Role/Role";
import Scanner from "./pages/Scanner";
import Tenant from "./pages/Tenant/Tenant";
import UsersStaff from "./pages/Users/UsersStaff";
import UsersTenant from "./pages/Users/UsersTenant";
import VoucherOrder from "./pages/VoucherList";
import VoucherList from "./pages/VoucherOrder";
import FormVoucher from "./pages/VoucherOrder/parts/form2";
import PickupPoint from "./pages/PickupPoint";
import theme from "./theme";
import Runner from "./pages/Runner";
import MyIncome from "./pages/MyIncome";
import Saldo from "./pages/Saldo";
import Withdraw from "./pages/Saldo/parts/Withdraw";
import Rekonsiliasi from "./pages/Rekonsiliasi";
import RekonsiliasiResult from "./pages/Rekonsiliasi/result";
import RekonsiliasiFailed from "./pages/Rekonsiliasi/failed";
import Disbursement from "./pages/Disbursement";
import Editorial from "./pages/Editorial";
import PromoHighlight from "./pages/PromotionHighlight/PromoMall";
import useNotif from "./Helpers/useNotif";
import { ToastNotification } from "./components/Snackbars/Toast";
import Settings from "./pages/Settings";
import ForgotPassword from "./pages/Login/parts/ForgotPassword";
import NewProduct from "./pages/Product";
import ProductCurrated from "./pages/ProductCurrated";
import Newsletter from "./pages/Newsletter";
// import VoucherReport from "./pages/VoucherReport";
import ProductRecommendation from "./pages/ProductRecommendation";
import { QueryClient, QueryClientProvider } from "react-query";
import NewDelivery from "./pages/Delivery/NewDelivery";
import FormProperty from "./pages/Property/parts/FormProperty";
import Landing from "./pages/Landing/part/FormProperty";
import FormPropertyEdit from "./pages/Property/parts/FormPropertyEdit";
import PropertyDelivery from "./pages/PropertyDelivery";
// import Loading from "./components/";

// import qiscus from 'components/utils/QiscusSDKCore';
// import { EventEmitter } from 'components/utils/events';
// import Dexie from 'dexie';

function AppRouter() {
  let roomId = localStorage.getItem("roomId");
  const { notif, displayNotification } = useNotif(roomId);

  const redirectToOrder = () => {
    History.push("order");
  };

  // onMessageListener().then(payload => {
  //   console.log(payload);
  //   const options = {
  //     body: `${payload?.notification?.body}`,
  //     icon: payload?.data?.icon || ``,
  //     vibrate: [50, 100, 50, 100, 50, 100],
  //     data: {
  //       dateOfArrival: Date.now(),
  //       primaryKey: 1,
  //       action: process.env.PUBLIC_URL + `${payload?.data?.action}`
  //     }
  //   }
  //   displayNotification(payload?.notification?.title, options);
  // }).catch(err => console.log('failed: ', err));

  React.useEffect(() => {
    let newestNotif = notif.slice(-1);

    if (newestNotif.length > 0) {
      const data = newestNotif[0];
      ToastNotification(
        "top",
        "right",
        "VIEW NEW ORDER",
        redirectToOrder,
        true,
        true
      );
    }

    return () => {
      newestNotif = [];
    };
  }, [notif]);

  const clearLocalStorage = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    History.push("/login");
  };

  const queryClient = new QueryClient();

  return (
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <Router history={History}>
          <Switch>
            <Route exact path="/login" name="Login" component={Login} />
            <Route
              exact
              path="/forgot_password"
              name="Forgot Password"
              component={ForgotPassword}
            />
            <Route exact path="/scanner" name="Scanner" component={Scanner} />
            <Route exact path="/" name="Root" render={clearLocalStorage} />
            <Route exact path="/home" name="Home" component={Home} />
            <PrivateRoute
              exact
              path="/settings"
              name="Pengaturan"
              component={Settings}
            />
            <PrivateRoute
              exact
              path="/settings/security"
              name="Pengaturan"
              component={Settings}
            />
            <PrivateRoute
              exact
              path="/delivery"
              name="Delivery"
              component={NewDelivery}
            />
            <PrivateRoute
              exact
              path="/usersstaff"
              name="Staff Management"
              component={UsersStaff}
            />
            <PrivateRoute
              exact
              path="/userstenant"
              name="User Management"
              component={UsersTenant}
            />
            <PrivateRoute
              exact
              path="/role"
              name="Role Management"
              component={Role}
            />
            <PrivateRoute
              exact
              path="/property"
              name="List Property"
              component={Property}
            />
            <PrivateRoute
              exact
              basePath="/property"
              action="create"
              path="/property/add"
              name="Add Property"
              component={FormProperty}
            />
            <PrivateRoute
              exact
              basePath="/property"
              action="update"
              path="/property/edit/:id"
              name="Edit Property"
              component={FormPropertyEdit}
            />
            <PrivateRoute
              exact
              path="/pickuppoint"
              name="Pick Up Point"
              component={PickupPoint}
            />
            <PrivateRoute
              exact
              path="/property-delivery"
              name="Property Delivery"
              component={PropertyDelivery}
            />
            <PrivateRoute
              exact
              path="/tenant"
              name="Tenant Management"
              component={Tenant}
            />
            <PrivateRoute
              exact
              path="/categoryproduct"
              name="Category Management"
              component={CategoryProduct}
            />
            <PrivateRoute
              exact
              path="/categorytenant"
              name="Tenant Category"
              component={CategoryTenant}
            />

            <PrivateRoute
              exact
              path="/product"
              name="Product Management"
              component={NewProduct}
            />
            <PrivateRoute
              exact
              path="/order"
              name="Order"
              component={NewOrder}
            />
            <PrivateRoute
              exact
              path="/runner"
              name="Runner"
              component={Runner}
            />

            <PrivateRoute
              exact
              path="/promotenant"
              name="Promo Tenant"
              component={PromoTenant}
            />
            <PrivateRoute
              exact
              path="/promomall"
              name="Promo Mall"
              component={PromoMall}
            />
            <PrivateRoute
              exact
              path="/promomanagement"
              name="Promo Management"
              component={PromoManagement}
            />

            <PrivateRoute
              exact
              path="/voucherReport"
              name="Voucher Report"
              component={VoucherList}
            />
            <PrivateRoute
              exact
              path="/voucherMall"
              name="Voucher Order"
              component={VoucherList}
            />
            <PrivateRoute
              exact
              basePath="/voucherMall"
              action="create"
              path="/voucherMall/add"
              name="Add Voucher"
              component={FormVoucher}
            />
            <PrivateRoute
              exact
              path="/penghasilansaya"
              name="Penghasilan Saya"
              component={MyIncome}
            />
            <PrivateRoute
              exact
              path="/saldosaya"
              name="Saldo Saya"
              component={Saldo}
            />
            <PrivateRoute
              exact
              path="/saldosaya/withdraw"
              name="Saldo Saya"
              component={Withdraw}
            />
            <PrivateRoute
              exact
              path="/rekonsiliasi"
              name="Rekonsiliasi"
              component={Rekonsiliasi}
            />
            <PrivateRoute
              exact
              basePath="/rekonsiliasi"
              action="read"
              path="/rekonsiliasi/result/:id"
              name="Rekonsiliasi"
              component={RekonsiliasiResult}
            />
            <PrivateRoute
              exact
              path="/rekonsiliasi/failed"
              name="Rekonsiliasi"
              component={RekonsiliasiFailed}
            />
            <PrivateRoute
              exact
              path="/disbursement"
              name="Disbursement"
              component={Disbursement}
            />
            <PrivateRoute
              exact
              path="/editorial"
              name="Editorial"
              component={Editorial}
            />
            <PrivateRoute
              exact
              path="/curated"
              name="ProductCurrated"
              component={ProductCurrated}
            />
            <PrivateRoute
              exact
              path="/recommendation"
              name="recommendation"
              component={ProductRecommendation}
            />
            <PrivateRoute
              exact
              path="/promoHighlight"
              name="promoHighlight"
              component={PromoHighlight}
            />
            <PrivateRoute
              exact
              path="/newsletter"
              name="Newsletter"
              component={Newsletter}
            />
            <PrivateRoute
              exact
              path="/landing"
              name="Landing"
              component={Landing}
            />

            <Route path="*" component={NotFound} />
            {/* <PrivateRoute exact path='/overview/:id' name="Overview" component={LoadableComponent(() => import('pages/overview'))} /> */}
          </Switch>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export default withRouter(AppRouter);
